import React from 'react';
import { connect } from 'react-redux';
import { FreeLayout } from 'Layouts';

export const HomeComponent = ({ welcomeScreen }) => {
  return <FreeLayout className="welcome" screenName={welcomeScreen} />;
};

const mapStateToProps = ({ appConfig: { screens } = {} }) => ({
  welcomeScreen: screens.welcomeScreen,
});

export const HomeContainer = connect(mapStateToProps)(HomeComponent);
